/* @flow */
import React from 'react';
import TextEntities from 'lib/TextEntities';
import TextWithEntities from 'components/TextWithEntities.jsx';
import { ChatSystemMessage } from 'entities/ChatMessage';

import cx from 'classnames';
import './styles/MessageSystemItem.scss';

class MessageSystemItem extends React.Component {
  static propTypes = {
    message: React.PropTypes.instanceOf(ChatSystemMessage).isRequired,
  };

  renderMessageBody() {
    const { message } = this.props;
    const body = message.getBody();
    if (!body) {
      return null;
    }

    const entities = [].concat(
      TextEntities.parseEmoji(body),
      TextEntities.parseNewlines(body),
      TextEntities.parseLeadingWhitespace(body),
      TextEntities.parseUrls(body),
      TextEntities.parseAttributes(message.getBodyAttributes())
    );

    return (
      <div className={cx({ 'MessageSystemItem-body': true })}>
        <TextWithEntities text={body} entities={entities} />
      </div>
    );
  }

  render() {
    return (
      <div className="MessageSystemItem">
        {this.renderMessageBody()}
      </div>
    );
  }
}

export default MessageSystemItem;



// WEBPACK FOOTER //
// ./src/chat/components/MessageSystemItem.jsx